import WebServiceRequest from "@/libs/Api/WebServiceRequest";

class CreateLessonQuestionsCount extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("LessenQuestionsCount/Create");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class GetAllLessonQuestionsCount extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("LessenQuestionsCount/GetAll");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class UpdateLessonQuestionsCount extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("LessenQuestionsCount/Update");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

export {
  CreateLessonQuestionsCount,
  GetAllLessonQuestionsCount,
  UpdateLessonQuestionsCount,
};
